module.exports = __webpack_public_path__ + "static/media/polojenie_karta_ychast.c360ef9f.doc";